import React, {useContext} from "react"
import {AssociatePerformanceContextV2} from "./context/AssociatePerformanceContextV2";
import Row from "@amzn/meridian/row";
import Heading from "@amzn/meridian/heading";
import Table, {TableCell, TableRow} from "@amzn/meridian/table"
import {AssociateFilterContextV2} from "./context/AssociateFilterContextV2";
import {FormattedMessage} from "react-intl";
import Tooltip from "@amzn/meridian/tooltip";
import AssociatePerformanceMetricsV2 from "./AssociatePerformanceMetricsV2";
import AssociateFilterWrapperV2 from "./AssociateFilterWrapperV2";
import {useDeviceLayout} from "../common/context/DeviceLayoutContext";

const AssociatePerformanceViewV2 = (props) => {
    const {states} = useContext(AssociateFilterContextV2)
    const {viewModel, dispatch} = useContext(AssociatePerformanceContextV2);
    const {spacingInset_shorthand3} = useDeviceLayout();

    const onSort = (sortDetails) => {
        dispatch({
            type: 'SORT_DATA',
            data: {column: sortDetails.sortColumn, direction: sortDetails.sortDirection}
        })
    }

    const sortedAssociatePerformance = [...viewModel.associatePerformance];
    sortedAssociatePerformance && sortedAssociatePerformance.sort((a, b) => {
        if (a[viewModel.sortPref.column] < b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? -1 : 1
        }
        if (a[viewModel.sortPref.column] > b[viewModel.sortPref.column]) {
            return viewModel.sortPref.direction === "ascending" ? 1 : -1
        }
        return 0
    })

    return (
        <div>
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset={spacingInset_shorthand3}>
                <div>
                    <Heading level={2} type="h400" alignment="left">
                        <FormattedMessage id="associate.associates" defaultMessage="Outbound Associates"/>
                    </Heading>
                    <AssociateFilterWrapperV2/>
                    <AssociatePerformanceMetricsV2 {...props}/>
                    <div style={{ overflowX: "auto", width: "100%" }}>
                        <Table headerRows={1} spacing="small"
                               fixHeaderRows={true}
                               fixHeaderRowsFullWidth={true}
                               headerColumns={1}
                               stickyHeaderColumn={true}
                               sortColumn={viewModel.sortPref.column}
                               sortDirection={viewModel.sortPref.direction}
                               showStripes={true}
                               showDividers={true}
                               onSort={onSort}>
                            <TableRow>
                                <TableCell sortColumn="alias">
                                    <Tooltip position="top"
                                             title={"List of all associates who were assigned a stage task during the day."}>
                                        <FormattedMessage id="associate.associate" defaultMessage="Associate"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="active">
                                    <Tooltip position="top"
                                             title={"Yes, if associate is currently assigned to a stage task. No, otherwise."}>
                                        <FormattedMessage id="associate.active"
                                                          defaultMessage="Stage Task currently assigned"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="inActivePeriodInSeconds">
                                    <Tooltip position="top"
                                             title={"If currently not assigned any stage task, this is the time " +
                                             "since last stage task was completed. If currently assigned any stage task, " +
                                             "this is the time since last stage scan happened for this stage task."}>
                                        <FormattedMessage id="associate.lastActivityTime"
                                                          defaultMessage="Time since last stage activity"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="currentRouteCode">
                                    <Tooltip position="top"
                                             title={"Displays the route code of the stage task assigned"}>
                                        <FormattedMessage id="associate.picklistId" defaultMessage="Route Code"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="currentSourceLoc">
                                    <Tooltip position="top"
                                             title={"Displays the floor location of the stage task assigned"}>
                                        <FormattedMessage id="associate.picklistId" defaultMessage="Floor Location"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="currentPicklistDurationInSeconds">
                                    <Tooltip position="top"
                                             title={"This will be blank for associates not assigned any stage task. " +
                                             "For active associates, this will be duration of current stage task."}>
                                        <FormattedMessage id="associate.taskDuration"
                                                          defaultMessage="Current stage task duration"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="totalIdleTimeInSeconds">
                                    <Tooltip position="top"
                                             title={"Total time between current time and staged time post 3 minutes staging was completed." +
                                                 "This will be blank for associates currently performing the staging task"}>
                                        <FormattedMessage id="associate.totalIdleTime"
                                                          defaultMessage="Total idle time between stage tasks"/>
                                    </Tooltip>
                                </TableCell>
                                <TableCell sortColumn="lastLocation">
                                    <Tooltip position="top"
                                             title={"Last location of the cart by any associate"}>
                                        <FormattedMessage id="associate.lastLocation"
                                                          defaultMessage="Last Task"/>
                                    </Tooltip>
                                </TableCell>
                            </TableRow>
                            {sortedAssociatePerformance.map(associate => (
                                (states.length === 0 || states.includes(associate.active)) ? (
                                    <TableRow key={associate.alias}>
                                        <TableCell>{associate.alias}</TableCell>
                                        <TableCell>{associate.active}</TableCell>
                                        <TableCell>{associate.lastActivityTime}</TableCell>
                                        <TableCell>{associate.routeCode}</TableCell>
                                        <TableCell>{associate.sourceLocation}</TableCell>
                                        <TableCell>{associate.stagingDuration}</TableCell>
                                        <TableCell>{associate.totalIdleTime}</TableCell>
                                        <TableCell>{"Stage"}</TableCell>
                                    </TableRow>
                                ) : null
                            ))}
                        </Table>
                    </div>
                </div>
            </Row>
        </div>
    );
}

export default AssociatePerformanceViewV2


// WEBPACK FOOTER //
// ./src/components/outboundassociate/AssociatePerformanceViewV2.js